import { client } from "api";
import { Company } from "models/Company";
import { CompanyComment } from "models/CompanyComment";

export type GetCommentsRequest = Pick<Company, "id">;

export type GetCommentsResponse = CompanyComment[];

export const getComments = ({ id }: GetCommentsRequest) =>
  client.get<GetCommentsResponse>(`/company/${id}/comments`).then((res) => res.data);
